import {
  Component,
  inject,
  effect,
  HostListener,
  DestroyRef,
} from "@angular/core";
import { CustomersService } from "src/app/customers/customers.service";
import { DataService } from "src/app/data.service";
import {
  ColumnState,
  GridApi,
  GridReadyEvent,
  IRowNode,
} from "ag-grid-community";
import * as _latinize from "latinize";
import { MatDialog } from "@angular/material/dialog";
const latinize = _latinize;
import { db } from "src/app/db.service";
import { Observable } from "rxjs";
import { slideAnimation } from "src/app/shared/fade.animation";
import { FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";

@Component({
  selector: "app-customers-full",
  templateUrl: "./customers-full.component.html",
  styleUrls: ["./customers-full.component.css"],
  animations: [slideAnimation],
})
export class CustomersFullComponent {
  @HostListener("window:keyup", ["$event"])
  keyEvent(event: KeyboardEvent) {
    if (event.key == "Escape") {
      this.showFilterOptions = false;
    }
  }

  searched: boolean = false;
  _dataService = inject(DataService);
  destroyRef = inject(DestroyRef);
  _customersService = inject(CustomersService);
  router = inject(Router);

  dataLoading: boolean = false;
  navButtons = [
    {
      name: "Yeni Tərəf-Müqabil",
      icon: "add",
      function: () => this._customersService.customerDialog(),
    },
    {
      name: "Çap et",
      icon: "print",
      function: () => this.print(),
    },
    {
      name: "Bütün Müştərilər",
      icon: "people",
      function: () => this.router.navigate(["./CustomersAll"]),
    },
  ];
  showFilterOptions: boolean = false;
  selectedCustomerGroups = this._formBuilder.group({});

  customerGroups = this._customersService.getCustomerFilters();
  customerGroupCategoryIds = [];

  columnDefs = [
    {
      headerName: "id",
      field: "customerId",
      hide: true,
    },
    {
      headerName: "Tərəf-Müqabil",
      field: "customerName",
      sortable: true,
      flex: 3,
      minWidth: 100,
      filterValueGetter: (params) =>
        this._dataService.latinizeText(params, "customerName"),
      cellClass: (params) => {
        return "bg-gray";
      },
    },
    {
      headerName: "Əvvələ Qalıq",
      field: "balanceBefore",
      sortable: true,
      flex: 2,
      minWidth: 150,
    },
    {
      headerName: "Gedən",
      field: "incomeTotal",
      sortable: true,
      flex: 2,
      minWidth: 120,
      cellRenderer: (params) => {
        let res = params.data.sellsTotal + params.data.outgoingTotal;
        return res % 1 === 0 ? res : res.toFixed(2);
      },
    },
    {
      headerName: "Gələn",
      field: "stocksTotal",
      sortable: true,
      flex: 2,
      minWidth: 150,
      cellRenderer: (params) => {
        let res = params.data.stocksTotal + params.data.incomeTotal;
        return res % 1 === 0 ? res : res.toFixed(2);
      },
    },
    {
      headerName: "Fərq",
      field: "balance",
      sortable: true,
      flex: 2,
      minWidth: 120,
      cellClass: (params) => {
        return params.value < 0 ? "minusValueRedColor" : "";
      },
    },
    {
      headerName: "Yekun",
      field: "finalBalance",
      colId: "final",
      sortable: true,
      flex: 2,
      minWidth: 150,
      cellRenderer: (params) => {
        let res = params.value;
        if (params.data.paymentTimeIsDue && res && params.value > 1) {
          res += `<span class="material-symbols-outlined" style="font-size: 15px; color: red;position: absolute; right: 5px; top: 50%; transform: translateY(-50%)">search_activity</span>`;
        }
        return res;
      },
      cellClass: (params) => {
        return params.value < 0 ? "bg-red" : params.value > 0 ? "bg-green" : "";
      },
    },
    {
      headerName: "Yekun Debit",
      field: "finalBalance",
      colId: "finalDebit",
      hide: true,
      sortable: true,
      flex: 2,
      minWidth: 150,
      cellRenderer: (params) => {
        let res = params.value >= 0 ? params.value : null;
        if (params.data.paymentTimeIsDue && res && params.value > 1) {
          res += `<span class="material-symbols-outlined" style="font-size: 15px; color: red;position: absolute; right: 5px; top: 50%; transform: translateY(-50%)">search_activity</span>`;
        }
        return res;
      },
    },
    {
      headerName: "Yekun Kredit",
      field: "finalBalance",
      sortable: true,
      hide: true,
      colId: "finalCredit",
      flex: 2,
      minWidth: 150,
      cellRenderer: (params) => {
        return params.value < 0 ? -params.value : null;
      },
    },
  ];
  colDefs = this.columnDefs;
  protected gridApi!: GridApi;
  agGridData$: Observable<any[]>;

  constructor(public dialog: MatDialog, private _formBuilder: FormBuilder) {
    effect(async () => {
      if (this._dataService.customers() || this._dataService.dbChanged()) {
        this.agGridData$ = await this._customersService.getCustomersBalance(
          true
        );
        if (this.gridApi) this.filterChanged();
      }
    });
  }

  async getStocks() {
    const result = await db.stock.toArray();
    return result;
  }

  onGridReady(params: GridReadyEvent) {
    hideZeros = true;
    this.gridApi = params.api;
    this.gridApi.setGridOption("includeHiddenColumnsInQuickFilter", true);
    var defaultSortModel: ColumnState[] = [
      { colId: "customerName", sort: "asc", sortIndex: 0 },
    ];
    params.api.applyColumnState({ state: defaultSortModel });
    this.filterChanged();
  }

  filterDate(event: any) {
    if (event.value) {
      this._customersService.getCustomersBalance(true);
    }
  }

  // FILTER TABLE
  applyFilter(val) {
    if (!this.searched) {
      this.searched = true;
      hideZeros = false;
    }
    this.gridApi.setGridOption("quickFilterText", val);
    this._customersService.sumDebit = 0;
    this._customersService.sumKredit = 0;
    this.gridApi.forEachNodeAfterFilterAndSort((node) => {
      this._customersService.sumDebit +=
        node.data.finalBalance >= 0 ? node.data.finalBalance : 0;
      this._customersService.sumKredit +=
        node.data.finalBalance < 0 ? node.data.finalBalance : 0;
    });
  }

  isExternalFilterPresent(): boolean {
    return filterTable !== false;
  }

  doesExternalFilterPass(node: IRowNode<any>): boolean {
    let result = true;

    if (chipSelected.startsWith("Debitorlar")) {
      result = node.data.finalBalance > 0 ? true : false;
    }
    if (chipSelected.startsWith("Kreditorlar")) {
      result = node.data.finalBalance < 0 ? true : false;
    }
    if (customerGroupCategoryIds.length > 0) {
      result =
        customerGroupCategoryIds.includes(node.data.customerGroupId) && result
          ? true
          : false;
    }

    if (
      node.data.balanceBefore === 0 &&
      node.data.incomeTotal === 0 &&
      node.data.stocksTotal === 0 &&
      node.data.balance === 0 &&
      node.data.finalBalance === 0 &&
      hideZeros == true
    ) {
      result = false;
    }
    return result;
  }

  setChipSelected(val) {
    chipSelected = val;
    filterTable =
      customerGroupCategoryIds.length > 0 ? true : chipSelected ? true : false;
    this.gridApi.applyColumnState({ state: [], defaultState: { sort: null } });
    var defaultSortModel: ColumnState[] = [
      { colId: "customerName", sort: "asc", sortIndex: 0 },
      { colId: "finalDebit", hide: true },
      { colId: "finalCredit", hide: true },
      { colId: "final", hide: false },
    ];
    if (val == "Debitorlar") {
      defaultSortModel = [
        { colId: "finalCredit", hide: true },
        { colId: "finalDebit", hide: false, sort: "desc", sortIndex: 0 },
        { colId: "final", hide: true },
      ];
    }
    if (val == "Kreditorlar") {
      defaultSortModel = [
        { colId: "finalDebit", hide: true },
        { colId: "finalCredit", hide: false, sort: "asc", sortIndex: 0 },
        { colId: "final", hide: true },
      ];
    }
    this.gridApi.applyColumnState({ state: defaultSortModel });
    this.gridApi.onFilterChanged();
    if (this.searched) this.filterChanged();
  }

  changeFilter(item) {
    if (item.unfilter) {
      item.unfilter = false;
    } else if (item.filter) {
      item.filter = false;
      item.unfilter = true;
    } else {
      item.filter = true;
    }
    this.filterChanged();
  }

  filterChanged() {
    let cGrps = this.customerGroups;
    this._dataService.setLS(
      `${this._dataService.dbTable}_customerFilters`,
      cGrps
    );
    let ids = cGrps
      .filter((customerGrp) => customerGrp.filter)
      .map((customerGrp) => customerGrp.id);

    this.customerGroupCategoryIds = ids;

    customerGroupCategoryIds = ids.length
      ? cGrps
          .filter((customerGrp) => customerGrp.filter && !customerGrp.unfilter)
          .map((customerGrp) => customerGrp.id)
      : cGrps
          .filter((customerGrp) => !customerGrp.unfilter)
          .map((customerGrp) => customerGrp.id);

    this._dataService.setLS(
      `${this._dataService.dbTable}_filteredCustomerGroups`,
      customerGroupCategoryIds
    );
    filterTable = true;
    this.gridApi.onFilterChanged();

    // CALCULATE SUMS
    this._customersService.sumDebit = 0;
    this._customersService.sumKredit = 0;
    this.gridApi.forEachNodeAfterFilterAndSort((node) => {
      this._customersService.sumDebit +=
        node.data.finalBalance >= 0 ? node.data.finalBalance : 0;
      this._customersService.sumKredit +=
        node.data.finalBalance < 0 ? node.data.finalBalance : 0;
    });
  }

  clearFilterSelections() {
    this.customerGroups.forEach((b) => {
      b.filter = false;
      b.unfilter = false;
    });
    this._customersService.customersFiltered.set(false);
    filterTable = false;
    this.filterChanged();
  }

  print() {
    this.gridApi.setGridOption("domLayout", "print");

    // Get the data and process it with your cell renderers
    const processedData = this.getProcessedDataForPrint();

    const printWindow = window.open("", "_blank");

    printWindow?.document.write(`
    <html>
      <head>
        <title>JJ Erp</title>
        <style>
          table {
            width: 100%;
            border-collapse: collapse;
            margin: 20px 0;
          }
          th, td {
            border: 1px solid #ccc;
            padding: 8px;
            text-align: center;
          }
          th {
            background-color: #f5f5f5;
            font-weight: bold;
          }
          .hide-column {
            display: none;
          }
          tr td:first-child {
            text-align: left;
            padding-left: 1rem;
          }
          .logo {
            font-size: 50px;
            text-decoration: none;
            font-family: 'Titan One', fantasy, sans-serif;
            line-height: 19px;
            padding-left: 50px;
            font-style: italic;
            letter-spacing: 1px;
          }
        </style>
        <link
          href="https://fonts.googleapis.com/css2?family=Titan+One&display=swap"
          rel="stylesheet"
        />
      </head>
      <body>
        <div style="display: flex; align-items: center; padding: 0px 20px;">
          <h1 class='logo'>JJ</h1>
          <div style="margin-inline:auto">
            <h1 style="text-align: center;">Tərəf-Müqabil Hesabatı</h1>
            <h3 style="text-align: center; margin-top: -10px">${this._dataService.endDate.value.format(
              "DD-MM-YYYY "
            )}</h3>
          </div>
        </div>
       
        ${this.generatePrintTable(processedData)}
      </body>
    </html>
  `);

    printWindow?.document.close();
    printWindow?.print();
    setTimeout(() => {
      this.gridApi.setGridOption("domLayout", "normal");
    }, 500);
  }

  private getProcessedDataForPrint(): any[] {
    // Get all displayed rows from the grid
    const allData: any[] = [];
    this.gridApi.forEachNodeAfterFilterAndSort((node: any) => {
      if (node.data) {
        allData.push(this.processRowForPrint(node.data));
      }
    });

    return allData;
  }

  private processRowForPrint(row: any): any {
    return {
      ...row,
      type: this.getProcessedType(row),
      sum: this.getProcessedSum(row),
    };
  }

  private getProcessedType(row: any): string {
    switch (row.type) {
      case "Bank":
        return row.sum < 0 ? "Kassa Məxaric" : "Kassa Mədaxil";
      case "Return":
        return "Qaytarma";
      case "Sells":
        return "Satış";
      case "Stock Entry":
        return "Anbar Giriş";
      case "Stock Out":
        return "Anbar Çıxış";
      case "Production":
        return "İstehsalat";
      case "Salary":
        return "Maaş";
      default:
        return row.type;
    }
  }

  private getProcessedSum(row: any): number {
    return row.sum < 0 ? -row.sum : row.sum;
  }

  private generatePrintTable(data: any[]): string {
    const headers = this.columnDefs
      .filter((col) => !col.hide)
      .map((col) => `<th>${col.headerName}</th>`)
      .join("");

    const rows = data
      .map((row) => {
        const cells = this.columnDefs
          .filter((col) => !col.hide)
          .map((col) => `<td>${row[col.field]}</td>`)
          .join("");
        return `<tr>${cells}</tr>`;
      })
      .join("");

    return `
    <table>
      <thead>
        <tr>${headers}</tr>
      </thead>
      <tbody>
        ${rows}
      </tbody>
    </table>
  `;
  }
}
var filterTable = false;
var chipSelected = "Tərəf-Müqabillər";
var customerGroupCategoryIds = [];
var hideZeros = true;
